import _onetime from "onetime";
import _signalExit from "signal-exit";
import _process from "process";
var exports = {};
var process = _process;
const onetime = _onetime;
const signalExit = _signalExit;
exports = onetime(() => {
  signalExit(() => {
    process.stderr.write("\x1B[?25h");
  }, {
    alwaysLast: true
  });
});
export default exports;